var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicPricingReportDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1201 9.62H12.8701C12.4601 9.62 12.1201 9.28 12.1201 8.87C12.1201 8.46 12.4601 8.12 12.8701 8.12H18.1201C18.5301 8.12 18.8701 8.46 18.8701 8.87C18.8701 9.28 18.5401 9.62 18.1201 9.62Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62006 10.38C7.43006 10.38 7.24006 10.31 7.09006 10.16L6.34006 9.41001C6.05006 9.12001 6.05006 8.64001 6.34006 8.35001C6.63006 8.06001 7.11006 8.06001 7.40006 8.35001L7.62006 8.57001L9.34006 6.85001C9.63006 6.56001 10.1101 6.56001 10.4001 6.85001C10.6901 7.14001 10.6901 7.62001 10.4001 7.91001L8.15006 10.16C8.01006 10.3 7.82006 10.38 7.62006 10.38Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1201 16.62H12.8701C12.4601 16.62 12.1201 16.28 12.1201 15.87C12.1201 15.46 12.4601 15.12 12.8701 15.12H18.1201C18.5301 15.12 18.8701 15.46 18.8701 15.87C18.8701 16.28 18.5401 16.62 18.1201 16.62Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62006 17.38C7.43006 17.38 7.24006 17.31 7.09006 17.16L6.34006 16.41C6.05006 16.12 6.05006 15.64 6.34006 15.35C6.63006 15.06 7.11006 15.06 7.40006 15.35L7.62006 15.57L9.34006 13.85C9.63006 13.56 10.1101 13.56 10.4001 13.85C10.6901 14.14 10.6901 14.62 10.4001 14.91L8.15006 17.16C8.01006 17.3 7.82006 17.38 7.62006 17.38Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22.75H9.5C4.07 22.75 1.75 20.43 1.75 15V9C1.75 3.57 4.07 1.25 9.5 1.25H15.5C20.93 1.25 23.25 3.57 23.25 9V15C23.25 20.43 20.93 22.75 15.5 22.75ZM9.5 2.75C4.89 2.75 3.25 4.39 3.25 9V15C3.25 19.61 4.89 21.25 9.5 21.25H15.5C20.11 21.25 21.75 19.61 21.75 15V9C21.75 4.39 20.11 2.75 15.5 2.75H9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicPricingReportDark);
export default __webpack_public_path__ + "static/media/dynamic-pricing-report-dark.868c2e28b81d08254b9f840776a7b7eb.svg";
export { ForwardRef as ReactComponent };